/** @format */

import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import InputIcon from 'react-multi-date-picker/components/input_icon';
import PropTypes from 'prop-types';
import DatePicker from 'react-multi-date-picker';

import 'react-multi-date-picker/styles/backgrounds/bg-dark.css';
import { useFormikContext } from 'formik';
import ErrorMessage from '../Errors/ErrorMessage';

const Datepicker = ({
  name,
  defaultValue = false,
  minDate = null,
  title,
  serverError,
  disabled = false,
}) => {
  const { errors, values, setFieldValue } = useFormikContext();
  return (
    <div className='form-group d-flex flex-column'>
      <label className='f-13 text-left d-flex flex-row justify-content-start'>
        {title}
      </label>
      <DatePicker
        disabled={disabled}
        render={<InputIcon />}
        zIndex='9999999999999'
        calendar={persian}
        locale={persian_fa}
        value={values[name]}
        inputClass=''
        minDate={minDate === null ? new Date() : minDate}
        className=''
        name={name}
        portal
        format='YYYY/MM/DD'
        onChange={(e) => {
          if (!disabled) {
            setFieldValue(name, `${e.year}/${e.month}/${e.day}`, true);
          }
        }}
      />
      <ErrorMessage error={errors[name] ? errors[name] : serverError} />
    </div>
  );
};

DatePicker.propTypes = {
  name: PropTypes.string,
  defaultValue: PropTypes.string,
  minDate: PropTypes.any,
  title: PropTypes.string,
  serverError: PropTypes.any,
  disabled: PropTypes.bool,
};

export default Datepicker;
